import React, { useState, useContext, useEffect } from "react";
import "../styles/ImageGeneration.css";
import uploadIcon from "../assets/Upload.png";
import dropdownArrow from "../assets/dropdownarrow.png";
import { uploadImageGeneration } from "../helper";
import { GenerationContext } from "../context/GenerationContext";
import { db } from "../firebaseConfig";
import { doc, setDoc } from "firebase/firestore";
import { Tooltip } from "react-tooltip";
import toolTip from "../assets/tooltip.png";
const ImageGeneration = () => {
  const {
    setText,
    promptValue,
    setPromptValue,
    styleValue,
    setStyleValue,
    negativePrompt,
    setNegativePrompt,
    cfgValue,
    setCfgValue,
    seedValue,
    setSeedValue,
    stepsValue,
    setStepsValue,
    setImageText,
    setImage,
    strength,
    setStrength,
    control,
    setControl,
  } = useContext(GenerationContext);
  const [styleError, setStyleError] = useState(false);

  const [uploadedImage, setUploadedImage] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [displayImage, setDisplayImage] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [points, setPoints] = useState(localStorage.getItem("points") || 0);
  const [user] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setUploadedImage(file);
    setImage(file);

    // Create a URL for the uploaded image to display it
    const imageUrl = URL.createObjectURL(file);
    setDisplayImage(imageUrl);
    setImageError(false);
  };

  useEffect(() => {
    setPoints(localStorage.getItem("points"));
  }, [points]);

  const GenerateAction = async () => {
    setPoints(localStorage.getItem("points"));
    console.log(
      "Points in local storagee start: ",
      localStorage.getItem("points")
    );
    if (!styleValue) {
      setStyleError(true);
      return;
    }
    if (!uploadedImage) {
      setImageError(true);
      return;
    }

    if (!user) {
      alert("User not logged in. Please log in to generate images.");
      return;
    }
    if (points < 2) {
      alert("Not enough points to generate an image.");
      return;
    }
    setIsGenerating(true); // Set generating state to true
    const text = await uploadImageGeneration(
      promptValue,
      styleValue,
      uploadedImage,
      "remix",
      strength,
      control,
      stepsValue,
      cfgValue,
      negativePrompt
    );
    setText(text);
    setImageText("image");
    const newPoints = localStorage.getItem("points") - 2;
    setPoints(newPoints);

    localStorage.setItem("points", newPoints);
    console.log("Updated points:", newPoints);
    console.log("Points in local storage: ", localStorage.getItem("points"));
    const pointsEvent = new CustomEvent("pointsUpdated", {
      detail: { points: newPoints },
    });
    window.dispatchEvent(pointsEvent);

    try {
      const userDocRef = doc(db, "users", user.uid);
      await setDoc(userDocRef, { points: newPoints }, { merge: true });
      console.log("Points updated successfully in Firestore!");
    } catch (error) {
      console.error("Error updating Firestore document:", error);
    }
    setIsGenerating(false); // Set generating state to false after completion
  };

  return (
    <div className="container13">
      <div className="scrollView">
        <Tooltip id="steps-tooltip" place="top" />
        <h2 className="heading1">Prompt</h2>
        <textarea
          type="text"
          className="input"
          placeholder="Prompt"
          value={promptValue}
          onChange={(e) => setPromptValue(e.target.value)}
        />
        <div className="headingContainer">
          <h2 className="heading1">Style ID</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Style ID"
          />
        </div>
        <div className="dropdownContainer">
          {styleError && (
            <div className="errorMessage2">
              Please select a style from the dropdown
            </div>
          )}
          <select
            className="dropdown"
            value={styleValue}
            onChange={(e) => {
              setStyleValue(e.target.value);
              setStyleError(false);
            }}
          >
            <option value="" disabled>
              Style ID
            </option>
            <option value="21">21: Anime</option>
            <option value="29">29: Realistic</option>
            <option value="22">22: Imagine V1</option>
          </select>
          <img
            src={dropdownArrow}
            alt="dropdown arrow"
            className="dropdownIcon"
          />
        </div>
        <h2 className="heading1">Upload your photo or selfie</h2>
        <p className="description">
          Upload your photo and we'll generate an anime version of you.
        </p>
        {imageError && (
          <div className="errorMessage2">
            Please Upload Image to Generate Image
          </div>
        )}

        <div
          className="uploadContainer"
          onClick={() => document.getElementById("fileInput").click()}
        >
          {displayImage ? (
            <img src={displayImage} alt="Uploaded" className="uploadedImage" />
          ) : (
            <>
              <img src={uploadIcon} alt="Upload Icon" className="uploadIcon" />
              <p className="uploadText">Upload</p>
            </>
          )}
        </div>
        <input
          type="file"
          id="fileInput"
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleImageUpload}
        />
        <div className="headingContainer">
          <h2 className="heading1">Seed</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Seed Value"
          />
        </div>
        <textarea
          type="text"
          className="input"
          placeholder="Seed"
          value={seedValue}
          onChange={(e) => setSeedValue(e.target.value)}
        />
        <div className="headingContainer">
          <h2 className="heading1">Strength</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Strength"
          />
        </div>
        <textarea
          type="text"
          className="input"
          placeholder="Strength"
          value={strength}
          onChange={(e) => setStrength(e.target.value)}
        />
        <div className="headingContainer">
          <h2 className="heading1">Control</h2>
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="steps-tooltip"
            data-tooltip-content="Enter Control"
          />
        </div>
        <div className="dropdownContainer">
          <select
            className="dropdown"
            value={control}
            onChange={(e) => setControl(e.target.value)}
          >
            <option value="" disabled>
              Control
            </option>
            <option value="openpose">openpose</option>
            <option value="scribble">scribble</option>
            <option value="canny">canny</option>
            <option value="lineart">lineart</option>
            <option value="depth">depth</option>
          </select>
          <img
            src={dropdownArrow}
            alt="dropdown arrow"
            className="dropdownIcon"
          />
        </div>
        <div className="headingContainer">
          <h2 className="heading1">Steps</h2>
          <Tooltip id="step-tooltip" place="top" />
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="step-tooltip"
            data-tooltip-content="Enter the steps value (min: 30)"
          />
        </div>
        <textarea
          type="text"
          className="input"
          placeholder="Steps"
          value={stepsValue}
          onChange={(e) => setStepsValue(e.target.value)}
        />
        <div className="headingContainer">
          <h2 className="heading1">CFG</h2>
          <Tooltip id="step-tooltip" place="top" />
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="step-tooltip"
            data-tooltip-content="Enter CFG"
          />
        </div>
        <textarea
          type="text"
          className="input"
          placeholder="CFG"
          value={cfgValue}
          onChange={(e) => setCfgValue(e.target.value)}
        />
        <div className="headingContainer">
          <h2 className="heading1">Negative Prompt</h2>
          <Tooltip id="step-tooltip" place="top" />
          <img
            src={toolTip}
            alt="Tooltip Icon"
            className="tooltipIcon"
            data-tooltip-id="step-tooltip"
            data-tooltip-content="Enter Negative Prompt"
          />
        </div>
        <textarea
          className="inputPrompt"
          placeholder="Negative Prompt"
          value={negativePrompt}
          onChange={(e) => setNegativePrompt(e.target.value)}
        />
        <button
          className="generateButton"
          onClick={GenerateAction}
          disabled={isGenerating}
        >
          {isGenerating ? "Generating..." : "Generate"}
        </button>
      </div>
    </div>
  );
};

export default ImageGeneration;
